/**
 * Calculate totals for proposal items
 * @param {Array} items - Array of proposal items with pricing details
 * @returns {Object} Object containing totalClientPrice, totalBuilderCost, estimatedProfit
 */
export const calculateProposalTotals = (items) => {
  return items.reduce((acc, item) => {
    const clientPrice = Number(item.clientPrice) || 0;
    const builderCost = Number(item.builderCost) || 0;
    
    acc.totalClientPrice += clientPrice;
    acc.totalBuilderCost += builderCost;
    acc.estimatedProfit = acc.totalClientPrice - acc.totalBuilderCost;
    
    return acc;
  }, { totalClientPrice: 0, totalBuilderCost: 0, estimatedProfit: 0 });
};

/**
 * Calculate builder cost from quantity and unit cost
 * @param {Number} quantity - Quantity of items
 * @param {Number} unitCost - Cost per unit
 * @returns {Number} Total builder cost
 */
export const calculateBuilderCost = (quantity, unitCost) => {
  return (Number(quantity) || 0) * (Number(unitCost) || 0);
};

/**
 * Calculate client price from builder cost and markup
 * @param {Number} builderCost - Builder cost
 * @param {Number} markup - Markup percentage
 * @returns {Number} Client price
 */
export const calculateClientPrice = (builderCost, markup) => {
  const cost = Number(builderCost) || 0;
  const markupPercent = Number(markup) || 0;
  
  return cost * (1 + (markupPercent / 100));
};

/**
 * Calculate margin percentage from client price and builder cost
 * @param {Number} clientPrice - Price charged to client
 * @param {Number} builderCost - Cost to builder
 * @returns {Number} Margin percentage
 */
export const calculateMargin = (clientPrice, builderCost) => {
  const price = Number(clientPrice) || 0;
  const cost = Number(builderCost) || 0;
  
  if (price <= 0) return 0;
  
  return ((price - cost) / price * 100).toFixed(2);
};

/**
 * Calculate markup percentage from client price and builder cost
 * @param {Number} clientPrice - Price charged to client
 * @param {Number} builderCost - Cost to builder
 * @returns {Number} Markup percentage
 */
export const calculateMarkup = (clientPrice, builderCost) => {
  const price = Number(clientPrice) || 0;
  const cost = Number(builderCost) || 0;
  
  if (cost <= 0) return 0;
  
  return ((price / cost - 1) * 100).toFixed(2);
};